export const endPoints = {
    auth: {
        login: "user/login/",
        googleLogin: "user/google/login/",
        logout: "user/logout/",
        refresh_token: "user/refresh-token/",
        profile: "user/user-summary/",
        fcm_token: "user/users/token/",
        register: "user/users/",
        forgot_password: "user/password/reset/",
        verify_forgot_password: "user/password/reset/confirm/",
        change_password: "user/change-password/",
        change_email: "user/users/change-email/",
        verify_email: "/user/registration/verify-email/",
        resend_verify_email: "/user/registration/resend-email/",
        get_id_details: "https://geolocation-db.com/json",
        user_preferences: "user/user-preferences/",
        transfer: "user/user-org-role-mapping/transfer/",
        transfer_list: "user/user-org-role-mapping/transfer-list/",
        unmapUser: "/user/user-org-role-mapping/unmap/",
        deleteUser: "/user/user-org-role-mapping/user-delete/", // public only
        deleteAccount: "/user/user-org-role-mapping/account-delete/", // enterprise only
    }, subscription: {
        calculate_subscription_cost: "subscriptions/user-owned-subscription-mapping/calculate-fee/",
        fetch_types: "subscriptions/subscriptions/",
        fetch_plans: "subscriptions/subscription-plans/",
        proceed_to_pay: "subscriptions/user-owned-subscription-mapping/",
        payment: "subscriptions/user-owned-subscription-mapping/payment-history/",
        payment_legacy: "subscriptions/payment/",
        payment_overview: "subscriptions/payment/overview/",
        status: "subscriptions/payment/status/",
        payment_gateway_list: "subscriptions/payment/gateway-list/",
        download: "subscriptions/payment/download",
        cancel: "subscriptions/user-owned-subscription-mapping/cancel/",
        resume: "subscriptions/user-owned-subscription-mapping/resume/",
        geo_info: "subscriptions/user-owned-subscription-mapping/geo-info/",
    }, credits: {
        balance: "credits/balance/",
        ledger: "credits/ledger/",
        packs: "credits/packs/",
        checkout: "credits/packs/checkout/",
        // Usage vs plan + credit extras; expand buys a capacity pack with credits
        capacity: "credits/capacity/",
        expand: "credits/capacity/expand/",
        activities: "credits/activities/",
        waRates: "credits/wa-rates/",
        waEstimate: "credits/wa/estimate/",
        // Debits by day × activity for usage line chart (?start_date=&end_date=)
        usage: "credits/usage/",
    }, e_form: {
        callType: {
            all: "", client: "?form_mapping__client=",
        },
        create: "e-form/",
        clientInvite: "/e-form/invite/",
        fillForm: "/e-form/invite/",
        response: "/e-form/response/",
        pdfGenerationStatus: "/e-form/response/status/",
        generate_otp: "/e-form/response/generate_otp/",
        event: "/e-form/event/",
        access: "/e-form/access/",
        access_list: "/e-form/access/assigned/",
        unAssigned: "/user/users/",
        revoke: "/e-form/access/revoke/",
        download: "/e-form/response/generate/",
        mail: "/e-form/response/email/",
    }, client: {
        list: "clients/",
        export: "clients/export/",
        detail: "clients/{{id}}/",
        datasheet: "clients/{{id}}/datasheet/",
        lead: "leads/{{id}}/",
        tags: "clients/client_tags/",
        tagDetail: "clients/client_tags/{{id}}/",
    }, document: {
        upload: "documents/", download: "documents/download", email: "documents/email/", callType: {
            client: "?client=", form: "?form=",
        },
    }, communication: {
        getEmailConversation: "/email/", download: "email/attachment", thread: "email/thread",
    }, organization: {
        get: "user/organizations/",
        users: "user/users/my_org_users/",
        groupUsers: "user/groups/users/",
        invites: "subscriptions/invites/",
        myInvites: "subscriptions/invites/",
        invite: "subscriptions/user-owned-subscription-mapping/send-invite/",
        accept: "/subscriptions/user-subscription-mapping/accept-invite/",
        customField: "/custom-fields-for-lead/",
        customLeadsWhatsappMapping: "/template-mapping/",
        customLead: "/custom-status-for-lead/",
        customLeadBulk: "/custom-status-for-lead/bulk-update/",
        leadConversionRate: "/custom-status-for-lead/conversion-rate/",
        decline: "/subscriptions/user-subscription-mapping/decline-invite/",
        deleteOrg: "/user/user-org-role-mapping/delete-organization/",
        state: "/geo/state/",
        country: "/geo/country/",
        address: "user/organizations/address/",
    }, group: {
        get: "/user/groups/", selected: "/user/user-group-mapping/", userMapping: "/user/user-group-mapping/",
    }, lead: {
        get: "/leads/",
        export: "/leads/export/",
        growth: "/leads/growth/",
        lead_chart: "/leads/lead_chart/",
        appointment: "/appointments/slots/",
        calendarAppointment: "/appointments/",
        other_event: "/appointments/update-other-event/",
        calendarTask: "/task/",
        leadStat: "/leads/leads-summary/",
        leadUsers: "/user/users/",
        leadAppointments: "/leads/:id/appointments-for-lead/",
        bulkImport: "/leads/bulk_import/",
        bulkImportSampleCSV: "/leads/bulk_import_csv/",
        bulkDelete: "/leads/bulk-delete/",
        bulkUpdateStatus: "/leads/bulk-update-status/",
        bulkReassign: "/leads/bulk-reassign/",
        sources: "/leads/sources/",
        aiPrimaryLabels: "/leads/ai-primary-labels/",
        workStats: "/leads/work-stats/",
    }, task: {
        list: "/task/",
        board: "/task/board/",
        bulkDelete: "/task/bulk-delete/",
        bulkCompletion: "/task/bulk-update/",
        export: "/task/export/",
        exportTasks: "/task/export-tasks/",
    }, analytics: {
        conversion_ratio: "/leads-source-analytics/lead-conversion/",
        device_traffic: "/leads-source-analytics/device-traffic/",
        lead_source: "/leads-source-analytics/lead-source/",
        referral: "/leads-source-analytics/",
    }, announcement: {
        base: "/announcement/"
    }, commerce: {
        orders: "/commerce/orders/",
        orderAnalytics: "/commerce/orders/analytics/",
        orderStatusesUpdate: "/commerce/orders/{{id}}/statuses/",
        orderInvoice: "/commerce/orders/{{id}}/invoice/",
        catalogStatuses: "/commerce/statuses/",
        catalogStatus: "/commerce/statuses/{{id}}/",
        catalogStatusBulk: "/commerce/statuses/bulk-update/",
        productCategories: "/commerce/product-categories/",
        productCategory: "/commerce/product-categories/{{id}}/",
        shipping: "/commerce/shipping/",
        shippingStateOptions: "/commerce/shipping/state-options/",
        tax: "/commerce/tax/",
        taxStateOptions: "/commerce/tax/state-options/",
        discount: "/commerce/discount/",
        catalogs: "/commerce/catalogs/",
        catalog: "/commerce/catalogs/{{id}}/",
        catalogGlobalSettings: "/commerce/catalogs/global-settings/",
        catalogConnectWaba: "/commerce/catalogs/{{id}}/connect-waba/",
        catalogPushToFb: "/commerce/catalogs/{{id}}/push-to-fb/",
        catalogSyncFromFb: "/commerce/catalogs/{{id}}/sync-from-fb/",
        catalogSyncAllFromFb: "/commerce/catalogs/sync-all-from-fb/",
        catalogBusinesses: "/commerce/catalogs/businesses/",
        products: "/commerce/catalogs/{{catalog_id}}/products/",
        product: "/commerce/catalogs/{{catalog_id}}/products/{{id}}/",
        productsImportCsv: "/commerce/catalogs/{{catalog_id}}/products/import-csv/",
        productsExportCsv: "/commerce/catalogs/{{catalog_id}}/products/export-csv/",
        productSetVariantGroup: "/commerce/catalogs/{{catalog_id}}/products/{{id}}/set-variant-group/",
    }, integration: {
        listMessage: "/integration/whatsapp/",
        listEnquiryMessage: "/integration/whatsapp-enquiry/",
        liveSession: "/integration/whatsapp/live-session/",
        bulkWhatsapp: "/integration/whatsapp/bulk/",
        bulkWhatsappStatus: "/integration/whatsapp/bulk_status/",
        bulkSchedules: "/integration/whatsapp/bulk/schedules/",
        bulkScheduleDetail: "/integration/whatsapp/bulk/schedules/{{id}}/",
        bulkScheduleOccurrenceCancel:
            "/integration/whatsapp/bulk/schedules/{{id}}/occurrences/{{occurrence_id}}/cancel/",
        bulkBatches: "/integration/message/bulk_batches/",
        bulkBatchDetail: "/integration/message/bulk_batches/{{id}}/",
        bulkBatchRecipients: "/integration/message/bulk_batches/{{id}}/recipients/",
        templates: "/integration/whatsapp/templates/",
        catalogs: "/integration/whatsapp/catalogs/",
        deleteTemplates: "/integration/whatsapp/templates/{{id}}/",
        search: "/integration/whatsapp/search/",
        createConfig: "/integration/",
        whatsappPhoneNumberConfirmation: "/integration/confirmation/",
        whatsappAnalytics: "/integration/analytics/",
        messageStats: "integration/message_stats/",
        unidentifiedSender: "/unidentified-enquiry/",
        deleteUnidentifiedSender: "/unidentified-enquiry/{{id}}/",
        isWhatsappConfig: "/integration/whatsapp/config/",
        email: {
            config: "/integration/email/config/"
        },
        payment: {
            config: "/integration/payment/config/"
        },
        calendar: {
            config: "/integration/calendar/config/"
        },
        webhook: {
            config: "/integration/webhook/config/"
        },
        social: {
            config: "/integration/",
            pageConfig: "/integration/page/config/"

        },
        orderManagement: {
            config: "/integration/order-management/config/"
        },
        chatbot: {
            config: "/integration/chatbot/", update_status: "/integration/chatbot/update_status/",
        },
        ai: {
            trainWebsite: "/integration/ai/train/website/",
            trainUpload: "/integration/ai/train/upload/",
            trainText: "/integration/ai/train/text/",
            sources: "/integration/ai/train/sources/",
            source: "/integration/ai/train/sources/{{id}}/",
            feedback: "/integration/ai/train/feedback/",
            feedbackItem: "/integration/ai/train/feedback/{{id}}/",
            gaps: "/integration/ai/train/gaps/",
            gapAnswer: "/integration/ai/train/gaps/{{id}}/answer/",
            gapIgnore: "/integration/ai/train/gaps/{{id}}/ignore/",
            // Assistant persona (agent_name); org_id injected by CRM.
            orgSettings: "/integration/ai/org-settings/",
        },
        chatList: "/integration/whatsapp/chats/"
    },
    payment: {
        // GET lists online + manual payments; POST records a manual payment
        list: "/payment/payments/",
        create: "/payment/payments/",
        detail: "/payment/payments/{{id}}/",
        delete: "/payment/payments/{{id}}/",
        refund: "/payment/refund/",
    }, partner: {
        config: "/user/partner-config/",
    }, apiManagement: {
        list: "credentials/",
        create: "credentials/",
        detail: "credentials/{{id}}/",
        update: "credentials/{{id}}/",
        delete: "credentials/{{id}}/",
        revoke: "credentials/{{id}}/revoke/",
        auditLogs: "credentials/{{id}}/audit_logs/",
    }
    , support: {
        tickets: "/support-tickets/tickets/",
        ticketDetail: "/support-tickets/tickets/{{id}}/",
    },
    // AI marketing campaigns (IMAGE-header WhatsApp MARKETING)
    campaigns: {
        list: "/campaigns/",
        detail: "/campaigns/{{id}}/",
        brandKit: "/campaigns/brand-kit/",
        creativeDefaults: "/campaigns/creative-defaults/",
        enhancePrompt: "/campaigns/{{id}}/enhance-prompt/",
        generate: "/campaigns/{{id}}/generate/",
        creativeEdit: "/campaigns/{{id}}/creative/edit/",
        creativeRegenerate: "/campaigns/{{id}}/creative/regenerate/",
        creativeDownload: "/campaigns/{{id}}/creative/download/",
        creativeVersions: "/campaigns/{{id}}/creative/versions/",
        creativeVersionRestore: "/campaigns/{{id}}/creative/versions/{{versionId}}/restore/",
        submitTemplate: "/campaigns/{{id}}/submit-template/",
        audience: "/campaigns/{{id}}/audience/",
        runMode: "/campaigns/{{id}}/run-mode/",
        run: "/campaigns/{{id}}/run/",
        testSend: "/campaigns/{{id}}/test-send/",
        analytics: "/campaigns/{{id}}/analytics/",
        buttonReplies: "/campaigns/{{id}}/analytics/button-replies/",
        buttonRepliesExport: "/campaigns/{{id}}/analytics/button-replies/export/",
        generationJob: "/campaigns/jobs/{{id}}/",
        cancel: "/campaigns/{{id}}/cancel/",
    },
};
